import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Warehouse, Store, ShoppingBag } from 'lucide-react';
import SunjinShopOrders from './SunjinShopOrders';
import NASBodega from './NASBodega';
import NASShop from './NASShop';

const ShoppingHub = () => {
  const [activeTab, setActiveTab] = useState('sunjin');

  return (
    <div className="p-4 lg:p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">Shopping</h1>
        <p className="text-slate-500">Order and transfer products between suppliers and inventory locations</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full max-w-2xl grid-cols-3 mb-6">
          <TabsTrigger value="sunjin" className="flex items-center gap-1 text-xs sm:text-sm" data-testid="sunjin-orders-tab">
            <ShoppingBag size={16} />
            <span className="hidden sm:inline">Sunjin Shop</span>
            <span className="sm:hidden">Sunjin</span>
          </TabsTrigger>
          <TabsTrigger value="bodega-shop" className="flex items-center gap-1 text-xs sm:text-sm" data-testid="bodega-shop-tab">
            <Warehouse size={16} />
            <span>Bodega Shop</span>
          </TabsTrigger>
          <TabsTrigger value="nas-shop" className="flex items-center gap-1 text-xs sm:text-sm" data-testid="nas-shop-tab">
            <Store size={16} />
            <span className="hidden sm:inline">NAS Shop</span>
            <span className="sm:hidden">Shop</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="sunjin" className="-mt-4">
          <SunjinShopOrders embedded={true} />
        </TabsContent>

        <TabsContent value="bodega-shop" className="-mt-4">
          <NASBodega />
        </TabsContent>

        <TabsContent value="nas-shop" className="-mt-4">
          <NASShop />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ShoppingHub;
